import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import React, { Component } from "react";
var containerStyle = {
  position: "absolute",
  width: "30%",
  height: "271px"
};

var MapContainer = /*#__PURE__*/function (_Component) {
  _inherits(MapContainer, _Component);

  var _super = _createSuper(MapContainer);

  function MapContainer() {
    _classCallCheck(this, MapContainer);

    return _super.apply(this, arguments);
  }

  _createClass(MapContainer, [{
    key: "render",
    value: function render() {
      var lat = isNaN(+this.props.lat) ? false : +this.props.lat;
      var lng = isNaN(+this.props.long) ? false : +this.props.long;

      if (lat === false || lng === false) {
        return null;
      } else {
        return /*#__PURE__*/React.createElement(Map, {
          style: {
            border: "1px solid rgb(195, 207, 214)"
          },
          google: this.props.google,
          initialCenter: {
            lat: lat,
            lng: lng
          },
          zoom: 14,
          containerStyle: containerStyle
        }, /*#__PURE__*/React.createElement(Marker, {
          onClick: this.onMarkerClick,
          name: "Current location"
        }), /*#__PURE__*/React.createElement(InfoWindow, {
          visible: true,
          onClose: this.onInfoWindowClose
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, "STuff"))));
      }
    }
  }]);

  return MapContainer;
}(Component);

export default GoogleApiWrapper({
  apiKey: "AIzaSyD2s9vyxwQCR8y7F8pCGFgAvJFJ8inhRTU"
})(MapContainer);